export default __webpack_public_path__ + "71309b6b94d3d4df15b673f14464b808.svg";